import { useState, useRef, useEffect } from 'react';
import { useDatabase } from '../hooks/useDatabase';
import { useSelector } from 'react-redux';
import { getTitleFromSummary } from '../utils/stringManipulate';
import { Link, Navigate } from 'react-router';

const ChatMenu = () => {
  const [open, setOpen] = useState(false);
  const { fetchUserSummary } = useDatabase();
  const { items } = useSelector(state => state.summary);
  const menuRef = useRef();


  const toggleMenu = () => {
    setOpen(!open);
    fetchUserSummary();
  }

  const handleClickOutside = (e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={menuRef}>
    <div className="fixed left-10 top-10 z-50 bg-gray-100 border border-gray-300 p-2 rounded-xl backdrop-blur-md" onClick={toggleMenu}>
      <div className="relative">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"><path d="M21 7.75H3c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h18c.41 0 .75.34.75.75s-.34.75-.75.75ZM21 12.75H3c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h18c.41 0 .75.34.75.75s-.34.75-.75.75ZM21 17.75H3c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h18c.41 0 .75.34.75.75s-.34.75-.75.75Z" fill="#777777"></path></svg>
      </div>
    </div>
    {open && (
      <div className="fixed font-roboto h-full max-w-md left-0 top-0 w-64 bg-white shadow-lg rounded-lg border border-gray-200 p-4 text-sm space-y-2 z-50 ease-in-out overflow-auto">
          <span class="text-xl font-semibold">Saved Summary</span>
          <div class="mt-12 justify-space-between">
          {items.length === 0 ? (
            <p className="text-gray-500 text-center">No summaries saved yet.</p>
          ) : (
            items.map((item) => (
              <Link key={item.id} to={`/saved/${item.id}`}>
                <div
                  class="flex items-center gap-3 p-3 bg-gray-200 rounded-lg mb-4"
                >
                  <span class="text-gray-800">
                    {getTitleFromSummary(item.transcript)}
                  </span>
                </div>
              </Link>
            ))
          )}
          </div>
      </div>
    )}
    </div>
  );
};

export default ChatMenu;